import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { Icon, Dropdown } from "antd";

import { useAxios } from "../../../../shared/hooks/useAxios";
import { useNotification } from "../../../../shared/hooks/useNotification";
import { obterUrlEntidade } from "../urlEntidade";
import styles from "../Navbar.module.scss";

const MenuCanais = () => {
    const [entidadesCombo, setEntidadesCombo] = useState([]);

    const { fetchData } = useAxios();
    const notify = useNotification();

    const carregarEstabelecimentos = async () => {
        const { data, error } = await fetchData({
            method: "get",
            url: "/api/pagina-entidade/carregar-estabelecimentos-combo"
        });

        if (!error) setEntidadesCombo(data);
        else notify.error("Erro", "Não foi possível carregar canais!");
    };

    useEffect(() => {
        carregarEstabelecimentos();
    }, []);

    const subOptions = (
        <ul>
            {entidadesCombo.map(entidade => {
                const href = obterUrlEntidade(entidade);

                return (
                    <li key={entidade.id}>
                        {entidade.dominio ? (
                            <a href={href} target="_blank" rel="noopener noreferrer">
                                {entidade.nome}
                            </a>
                        ) : (
                            <Link to={href}>{entidade.nome}</Link>
                        )}
                    </li>
                );
            })}
        </ul>
    );

    return (
        <Dropdown overlay={subOptions} overlayClassName={styles.navbarDropdownMenu}>
            <NavLink to="#" className={styles.dropdownMenu}>
                Canais
                <Icon type="down" />
            </NavLink>
        </Dropdown>
    );
};

export default MenuCanais;
